fx.ns("models", class Creation extends fx.Model {

	constructor(data)
	{
		super(data);
	}


    get productType()
    {
        let productType = fx.get("productTypes").find({id : this.product_type_id});
        return productType ? productType.type : "";
    }

    get isBook()
    {
        return this.product_type_id == models.ProductType.BOOK;
    }

    get isPrint()
    {
        return this.product_type_id == models.ProductType.PRINT;
    }

    get isFrame()
    {
        return this.product_type_id == models.ProductType.FRAME;
    }

    get isCalendar()
    {
        return this.product_type_id == models.ProductType.CALENDAR;
    }

    get isPoster()
    {
        return this.product_type_id == models.ProductType.POSTER;
    }


    get cover()
	{
		return this.elements.getItemAt(0);
	}

    // to override
    get pageWidth()
    {
        return 0;
    }

    // to override
    get pageHeight()
    {
        return 0;
    }

    get coverWidth()
    {
        return this.pageWidth;
    }

    get coverHeight()
    {
        return this.pageHeight;
    }

	get propertiesNotStorable()
    {
        return ["id"];
    }
	
    get requestDefaultParams()
	{
		return {connectionid : fx.get("connectionid")};
	}

	
    // to Override
	get canRemove(){
		return true;
	}

    
    // to Override
	get canAdd(){
		return this.maxPages > this.numberPages;
	}

    // to override
	get numberPages()
	{
		return this.elements.length;
	}

    // to override
	get minPages()
	{
		return 0;
	}

    // to override
	get maxPages()
	{
		return 0;
	}

    // to override
	get totalPrice()
    {
		return 0;
    }
	
	/**
	 * This getter/setter is added in order to go over defautl value of photosort column ("added")
	 * With new editor, this column is an index.
	 */
	get photosSort()
	{
		let sort = Number(this.photosort);

		return isNaN(sort) ? 0 : sort;
	}

	set photosSort(val)
	{
		this.photosort = val;
	}

    // TODO 
    get creationWidth()
    {

    }

    get creationHeight()
    {

    }
	
	getElement(id)
	{
		return this.elements.find({id : id});
	}

	/***************************** Events ***********************/

	moveElement(page, referenceElement, side)
	{
		this.elements.moveItem(page, referenceElement, side);

		this.updateNumbering();
	}

	// if referenceElement set to true, creates a single page (with no backgrounds)
	addElement(referenceElement)
	{
		let newElement = new models.CreationElement({creation_id : this.id, layoutid : 0});
			
		let index = referenceElement ? ((referenceElement && referenceElement !== true) ? (this.elements.indexOf(referenceElement)+1) : 0) : this.elements.length;

		this.elements.addItemAt( index, newElement );

		newElement.addBackground();

		this.updateNumbering();

        return newElement;
	}

	onUpdated(action)
	{
		if (action.type == "removeItem" && action.data instanceof models.CreationElement)
			this.updateNumbering( action.history );	
	}

	/***************************** Actions  *********************/

    // Elements are sorted by their "number" parameter
    // so everytime an element is added/removed/moved we need to recalculate "number" for each element
    updateNumbering(history)
	{
		for (let i = 0; i < this.elements.length; i++)
		{
			let page = this.elements.getItemAt(i);

			let updates = {};
		
			if (page.number != i)
				updates.number = i;

			if (Object.keys(updates).length > 0)
				page.update( updates, {history : !!history} );				
		}

		this.event("numbering-changed")
	}


    // when picture if deleted, we need to remove it from
    // book content
	removePhoto(photo)
	{
		for (let i = 0; i < this.elements.length; i++)
		{
			let element = this.elements.getItemAt(i);
			for (let j = 0; j < element.components.length; j++)
			{
				let component = element.components.getItemAt(j);

				if (component.isPhoto && component.content == photo.id)
					component.content = "";
			}
		}
	}

    // when photo uploaded, it gets it final id
    // this function find all components using this photo, and update their content with new id
    // "update-id" tag is set when update is done, so Photo component can distinguish it's only an update (so no fill, history).
	updatePhotos(newid, oldid)
	{
		for (let i = 0; i < this.elements.length; i++)
		{
			let page = this.elements.getItemAt(i);

			for (let j = 0; j < page.components.length; j++)
			{
				let component = page.components.getItemAt(j);

				if ( component && component.isPhoto && component.content == oldid)
					component.update("update-id", {content : newid});
			}
		}
	}


    // apply layout to all elements
	applyLayout( layout )
	{
		for(let i = 0; i < this.elements.length; i++)
        {
            let element = this.elements.getItemAt(i);
            element.applyLayout( layout, this.pageWidth, this.pageHeight);
        }
	}

    // apply background to all pages
	applyBackgroundAll( background )
    {
        for(let i = 0; i < this.elements.length; i++)
        {
            let element = this.elements.getItemAt(i);
            element.applyBackground( background );
        }
    }

    // apply background color to all pages
	applyBackgroundColorAll(backgroundColor)
    {
        for(let i = 0; i < this.elements.length; i++)
        {
            let element = this.elements.getItemAt(i);
            element.updateBackgroundColor( backgroundColor, true);
        }
			
    }


});
